import { LoadingProps } from '../views/loading/loading.js'

export const getLoadingProps = (): LoadingProps => {
    return {
        title: 'Loading',
    }
}
